import React, { useState } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { apiFetch } from '../../../utils/api';
import 'bootstrap/dist/css/bootstrap.min.css';

export function Login({ onLogin }) {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await apiFetch('/api/admin/login', {
        method: 'POST',
        body: JSON.stringify({ login, password })
      });

      if (!res.ok) throw new Error('Ошибка входа');

      onLogin?.(); 
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card text-center">
        <div className="mb-4">
          <div className="bg-dark d-inline-block p-3 rounded-circle mb-3 shadow-sm" style={{ border: '2px solid var(--corp-accent)' }}>
            <i className="bi bi-shield-lock-fill text-white fs-2"></i>
          </div>
          <h2 className="text-uppercase mb-1">Вход</h2>
          <p className="text-muted small">Панель управления Complex Admin</p>
        </div>

        {error && (
          <Alert variant="danger" className="py-2 small border-0 shadow-sm mb-4">
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            {error}
          </Alert>
        )}

        <Form onSubmit={handleSubmit} className="text-start">
          <div className="login-input-group">
            <Form.Control 
              type="text" 
              placeholder="Логин" 
              value={login} 
              onChange={e => setLogin(e.target.value)} 
              disabled={loading}
              required 
            />
            <i className="bi bi-person-fill"></i>
          </div>

          <div className="login-input-group">
            <Form.Control 
              type="password" 
              placeholder="Пароль" 
              value={password} 
              onChange={e => setPassword(e.target.value)} 
              disabled={loading}
              required 
            />
            <i className="bi bi-lock-fill"></i>
          </div>

          <Button 
            className="btn-corp w-100 py-3 mt-2 shadow-sm d-flex align-items-center justify-content-center" 
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Проверка...
              </>
            ) : (
              'Войти в систему'
            )}
          </Button>
        </Form>

        <Link to="/" className="back-to-site">
          <i className="bi bi-arrow-left me-1"></i> Вернуться на главную
        </Link>
      </div>
    </div>
  );
}
